import { ArrowUp } from "lucide-react"
import { Button } from "@/components/ui/button"

// Closing call-to-action. The application form lives in the hero (top of the
// page), so this button scrolls back up to it via the #top anchor.
export function ClosingCta() {
  return (
    <section data-section="closing-cta" className="navy-panel dark border-b border-hairline">
      <div className="mx-auto max-w-3xl px-4 py-16 text-center sm:px-6 sm:py-20">
        <h2 className="section-title">Ready to fix your Google Ads?</h2>
        <p className="section-lead mx-auto mt-4 max-w-xl">
          Tell me about your account and I&apos;ll come back with a straight answer.
        </p>
        <div className="mt-8">
          <Button asChild size="lg">
            <a href="#top" data-track-click="closing_cta" data-sound="cta_click">
              <ArrowUp aria-hidden="true" className="h-4 w-4" />
              Apply to work together
            </a>
          </Button>
        </div>
      </div>
    </section>
  )
}
